// Recurring "Unclaimed Cell" grid-emblem watermark used across sections for consistent branding.
export const EmblemWatermark = ({ className = "" }) => (
  <img
    src="/brand/whitespaces-emblem.png"
    alt=""
    aria-hidden="true"
    className={`pointer-events-none absolute select-none opacity-[0.035] ${className}`}
  />
);

export default EmblemWatermark;
